<template>
    <div class="el-table-container">
        <el-form size="mini" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList()" @submit.native.prevent>
            <el-form-item prop="type" label="类型/描述：">
                <el-input size="small" v-model="searchForm.description" maxlength="50" placeholder="请输入类型/描述"
                          clearable></el-input>
            </el-form-item>
            <el-form-item prop="name" label="名称：">
                <el-input size="small" v-model="searchForm.name" maxlength="50" placeholder="请输入名称"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button type="primary" size="small" icon="el-icon-plus"
                           @click="add()">新增
                </el-button>
                <el-button type="danger" size="small" icon="el-icon-delete"
                           @click="del()">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small"
                height="100%"
                @selection-change="selectionChangeHandle"
                class="table" border>
            <el-table-column
                    type="selection"
                    width="50" fixed>
            </el-table-column>
            <el-table-column
                    prop="type"
                    label="类型">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false"
                             @click="view(scope.row.id)">{{scope.row.type}}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="description"
                    label="描述">
            </el-table-column>
            <el-table-column prop="enable" label="启用状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.enable"
                               active-value="0"
                               inactive-value="1" @change="enableChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    width="250"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="view(scope.row.id)">
                        详情
                    </el-button>
                    <el-button type="text" size="small" @click="edit(scope.row.id)">
                        修改
                    </el-button>
                    <el-button type="text" size="small" @click="del(scope.row.id)">
                        删除
                    </el-button>
                    <el-button type="text" size="small" @click="showRight(scope.row)">
                        管理键值
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="pageNo" :limit.sync="pageSize"
                    @pagination="refreshList"/>
        <!-- 弹窗, 新增 / 修改 -->
        <dict-type-form ref="dictTypeForm" @refreshDataList="refreshList"></dict-type-form>
        <el-drawer
                size="700px"
                :title="`数据字典值列表，所属类型: ${this.dictTypeTitle}`"
                :visible.sync="rightVisible"
                direction="rtl">
            <dict-value-list :dict-type-title="dictTypeTitle" ref="dictValueList"
                             @closeRight="closeRight"></dict-value-list>
        </el-drawer>

    </div>
</template>

<script>
    import DictTypeForm from './DictTypeForm'
    import DictValueList from './DictValueList'

    export default {
        data() {
            return {
                searchForm: {
                    description: '',
                    name: ""
                },
                dataList: [],
                pageNo: 1,
                pageSize: 20,
                total: 0,
                dataListSelections: [],
                dictTypeTitle: '',
                rightVisible: false,
                loading: false
            }
        },
        components: {
            DictTypeForm,
            DictValueList
        },
        activated() {
            this.refreshList()
        },
        methods: {
            // 获取数据列表
            refreshList(type) {
                if (type == 1) {
                    this.pageNo = 1;
                }
                this.loading = true
                this.$axios(this.api.allCommon.dictTypeList, {
                    'current': this.pageNo,
                    'size': this.pageSize,
                    'description': this.searchForm.description,
                    'name': this.searchForm.name,
                }, 'get').then(data => {
                    //console.log(data);
                    if (data && data.status) {
                        this.dataList = data.data.records
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增
            add() {
                this.$refs.dictTypeForm.init('add', '')
            },
            // 修改
            edit(id) {
                id = id || this.dataListSelections.map(item => {
                    return item.id
                })[0]
                this.$refs.dictTypeForm.init('edit', id)
            },
            // 查看
            view(id) {
                this.$refs.dictTypeForm.init('view', id)
            },
            // 启用
            enableChange(row) {
                this.loading = true
                this.$axios(this.api.allCommon.updateDictType, row, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error('操作失败')
                    }
                    this.refreshList()
                })
            },
            // 删除
            del(id) {
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                let ids = id || this.dataListSelections.map(item => {
                    return item.id
                }).join(',')
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(this.api.allCommon.dictDelete, {'ids': ids}, 'delete').then(data => {
                        if (data && data.status) {
                            console.log(data);
                            this.$message.success(data.data)
                            this.refreshList()
                            this.$dictUtils.refreshDictList()
                        }
                    })
                })
            },
            resetSearch() {
                this.searchForm.name = ''
                this.searchForm.description = ''
                this.$refs.searchForm.resetFields()
                this.refreshList()
            },
            showRight(row) {
                this.rightVisible = true
                this.$nextTick(() => {
                    this.$refs.dictValueList.refreshList(row.id)
                    this.dictTypeTitle = row.type
                })
            },
            closeRight() {
                this.rightVisible = false
            }
        }
    }
</script>
